export function mailtoLink(to, subject, body) {
  return `mailto:${to}?subject=${subject}&body=${body}`;
}
